import {TableHead, TableRow, TableCell, Checkbox, Box} from "@mui/material";
import SortableFilterableHeaderCell from "../headerCells/SortableFilterableHeaderCell";
import NumberComparisonFilterHeader from "../headerCells/NumberComparisonFilterHeader";
import SelectFilterableHeaderCell from "../headerCells/SelectFilterableHeaderCell";
import CustomCheckbox from "../../../../../../../components/Checkbox";

const MarketsBidHeader = ({
    hotelOrGroupType,
    allSelected,
    someSelected,
    onSelectAll,
    sortConfig,
    onSortChange,
    filters,
    onFilterChange,
    data,
    hasDeletableRow
}) => (
    <TableHead>
        <TableRow>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {hasDeletableRow && (
                        <CustomCheckbox
                            checked={allSelected}
                            onChange={onSelectAll}
                            checkboxStyles={{ padding: "2px 0 2px 9px" }}
                        />
                    )}
                    <SortableFilterableHeaderCell
                        label={`${hotelOrGroupType} Name`}
                        columnKey="label_entity"
                        sortConfig={sortConfig}
                        onSortChange={onSortChange}
                        filterValue={filters.label_entity}
                        onFilterChange={onFilterChange}
                        disableFilter={true}
                        hasCheckBox={hasDeletableRow}
                    />
                </Box>
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Device"
                    columnKey="label_device"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.label_device}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.label_device))]}
                />
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Market"
                    columnKey="label_market"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.label_market}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.label_market))]}
                />
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Bidding Option"
                    columnKey="bidding_option"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.bidding_option}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.bidding_option))]}
                />
            </TableCell>
            <TableCell>
                <NumberComparisonFilterHeader
                    label="Bidding Value"
                    columnKey="bidding_value"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.bidding_value}
                    onFilterChange={onFilterChange}
                />
            </TableCell>
            <TableCell />
        </TableRow>
    </TableHead>
);

export default MarketsBidHeader;